/**
 * Konsolidierte Texte für Studio-Zutrittsumfang (accessScope).
 * 1 = Nur Stammstudio, 2 = alle Studios, 3 = Nur ausgewählte Studios
 * Mit useI18n: text(accessScopeTexts.homeStudioOnly) usw.
 */

import { allStudiosTexts } from "./allStudiosTexts";
import type { LocalizedText } from "./i18n";

export const accessScopeTexts = {
  /** Value 1: Nur Stammstudio */
  homeStudioOnly: "Home studio only" as const,

  /** Value 2: alle Studios (referenziert allStudiosTexts) */
  allStudios: allStudiosTexts.label,

  /** Value 3: Nur ausgewählte Studios */
  selectedStudiosOnly: "Selected studios only" as const
} as const;

/** Optionen für Select (value 1, 2, 3) – mit text() aus useI18n verwenden */
export function buildAccessScopeOptions(text: (v: LocalizedText) => string) {
  return [
    { value: 1, label: text(accessScopeTexts.homeStudioOnly) },
    { value: 2, label: text(accessScopeTexts.allStudios) },
    { value: 3, label: text(accessScopeTexts.selectedStudiosOnly) }
  ];
}

/** Label für accessScope-Wert (1, 2, 3) – mit text() aus useI18n verwenden */
export function accessScopeToLabel(s: number | null | undefined, text: (v: LocalizedText) => string): string {
  const n = s == null ? null : Number(s);
  if (n === 1) return text(accessScopeTexts.homeStudioOnly);
  if (n === 2) return text(accessScopeTexts.allStudios);
  if (n === 3) return text(accessScopeTexts.selectedStudiosOnly);
  return "";
}
